/** Decorative avatar-initials palette — intentionally fixed, not theme-dependent. */
export const AVATAR_PALETTE = [
  '#FF8A65', '#7CB342', '#FFB300', '#5BB8FF', '#A78BFA', '#F472B6',
] as const;

/** Static fallback used in Storybook and non-component contexts. */
export const WC_COLORS = {
  bg: '#0B0613',
  panel: '#160C26',
  panelHi: '#1E1133',
  line: 'rgba(255,255,255,0.06)',
  lineHi: 'rgba(255,255,255,0.10)',
  ink: '#F4EFFF',
  inkDim: '#9C8FB8',
  inkMute: '#6B5E85',
  purple: '#9B7BFF',
  purpleHi: '#B79CFF',
  purpleDeep: '#5B2FCC',
  yellow: '#FFCB47',
  green: '#4ADE9B',
  red: '#FF5C7A',
  blue: '#5BB8FF',
  home: '#FF8A65',
  draw: '#9C8FB8',
  away: '#5BB8FF',
  textOnPrimary: '#FFFFFF',
  avatarPalette: ['#FF8A65', '#7CB342', '#FFB300', '#5BB8FF', '#A78BFA', '#F472B6'] as string[],
} as const;

export const MATCH_PICK_STATS_COPY = {
  BACK: 'Back',
  TITLE: 'Pick Stats',
  SCOPE_WORLDWIDE: 'Global',
  SCOPE_GROUP: 'Groups',
  TOTAL_PICKS: 'picks',
  OUTCOME_HOME: 'Home',
  OUTCOME_DRAW: 'Draw',
  OUTCOME_AWAY: 'Away',
  SCORE_HEAT_MAP_TITLE: 'Score Picks',
  ODDS_TITLE: 'Bookmaker Odds',
  ODDS_MORE: 'More markets',
  ODDS_LESS: 'Less',
  NO_ODDS: 'No odds available for this match.',
  NO_PICKS: 'No picks yet.',
  LOADING: 'Loading stats…',
  ERROR: 'Could not load pick stats.',
  SELECT_GROUP: 'Select squad',
  AWAY_LABEL: 'Away',
  HOME_LABEL: 'Home',
  YOUR_PICK: 'Your Pick',
  NO_PICK_YET: 'No pick yet',
  MAKE_PICK_PROMPT: 'Make your prediction before lock-in.',
  EDIT_PICK: 'Edit Pick',
  MAKE_PICK: 'Make Pick',
  PICK_LOCKED: 'Locked',
  TOP_SCORELINES_TITLE: 'Top Picks',
  MEMBER_PICKS_TITLE: "Squad's Picks",
  PICK_DISTRIBUTION_TITLE: 'Pick Distribution',
} as const;

/** Crest test ids (specs/champions-league T-37): the wrapper is the same either way, so a
 *  test discriminates flag from kit by what it contains, not by a different id. */
export const MATCH_PICK_STATS_TEST_IDS = {
  crest: (side: 'home' | 'away') => `pick-stats-crest-${side}`,
} as const;
